<!-- 管理员管理 -->
<template>
  <el-main>
    <div class="tableList">
      <div class="ele-table-tool-default">
        <el-button size="small" type="primary" icon="el-icon-plus" :style="{backgroundColor: $store.state.activeColor,borderColor: $store.state.activeColor}" @click="addBanner">新建</el-button>
      </div>
      <div class="tableContent">
        <el-table
          row-key="id"
          class="table"
          ref="tableData"
          :data="table.tableData"
          border
          :tree-props="{children: 'children'}"
          :height="table.tableHeight"
          element-loading-text="拼命加载中,请等待"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.1)"
        >
          <el-table-column width="100" prop="id" label="序号" align="center">
            <template slot-scope="scope">
              <span>{{ (paging.page-1)*paging.size+scope.$index+1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name"  label="用户名" align="center"></el-table-column>
          <el-table-column label="操作" align="center" width="140" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="handleOperation('edit', scope.row)" icon="el-icon-edit" :style="{color: $store.state.activeColor}">编辑</el-button>
              <el-popconfirm class="real_pop" title="您确定要删除该Banner信息吗？" @confirm="handleOperation('remove', scope.row)">
                <el-button class="danger" slot="reference" type="text" size="mini" icon="el-icon-delete"  v-if=" scope.row.id != 1">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <div class="tablePagination">
          <el-pagination
            class="customPagination"
            @size-change="handlePaginationChange"
            @current-change="handlePaginationCurrentChange"
            :current-page="paging.page"
            :page-sizes="[15, 25, 50]"
            :page-size="paging.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="paging.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </el-main>
</template>

<script>
  export default {
    name: 'administratorsManagement',
    data () {
      return {
        table: { // 表格参数
          tableData:[], // 表格数据
          tableHeight: null, // 表格高度
        },
        paging: { // 分页参数
          page: 1,// 页码
          size: 15, // 条数
          total: 0, // 总数
        },
        checkIds:[],//删除所选
      }
    },
    methods: {
      // 获取表格数据
      getList(){
        let parameter = [{
          "field":"status",
          "fun":"ne",
          "value": "0"
        }];
        this.$api.findAdmin({
          page:this.paging.page,
          size:this.paging.size,
          parameter: JSON.stringify(parameter)
        }).then(res => {
          if (res.data.status == 200) {
            this.paging.total = Number(res.data.data.total);
            this.table.tableData = res.data.data.records;
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
      },
      // 分页部分改变条数
      handlePaginationChange(val) {
        this.paging.size = val;
        this.paging.page = 1;
        this.getList();
      },
      // 分页部分改变页码
      handlePaginationCurrentChange(val) {
        this.paging.page = val;
        this.getList();
      },
      // 新建Banner
      addBanner(){
        this.$router.push({path:'/administratorsManagementOperation'});
      },
      // 批量添加修改列表
      setBatch(title){
        this.$api.saveOrUpdateAdminBatch({ parameter: JSON.stringify(this.table.tableData)}).then(res => {
          if (res.data.status == 200) {
            this.$message({
              message: title,
              type: 'success'
            });
            this.getList();
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
      },
      // 编辑/删除
      handleOperation(type,row){
        if (type == "edit") {  // 编辑操作
          this.$router.push({path:'/administratorsManagementOperation', query:{ data:row }});
        } else if (type == "remove") { // 删除操作
          for(let i = 0 ; i < this.table.tableData.length; i++){
            if (row.id == this.table.tableData[i].id){
              this.table.tableData[i].status = 0;
            }
          }
          let index = 0;
          for (let i = 0; i < this.table.tableData.length; i++){
            if (this.table.tableData[i].status != 0){
              index++;
              this.table.tableData[i].orderinfo = index;
            }
          }
          this.setBatch('删除成功！');
        }
      },
      // table的高度
      getTableHeight(){
        let that = this;
        if($(".table").length > 0) {
          // 表格高度初始化事件
          $(".table").height(window.innerHeight - $(".table").offset().top - 70);
          $(".table .el-table__empty-block").height(window.innerHeight - $(".table").offset().top - 132);
          that.table.tableHeight = window.innerHeight - $(".table").offset().top - 70;
          // 窗口改变事件
          window.onresize = function () { // 定义窗口大小变更通知事件
            if($(".table").length > 0) {
              $(".table").height(window.innerHeight - $(".table").offset().top - 70);
              $(".table .el-table__empty-block").height(window.innerHeight - $(".table").offset().top - 132);
              that.table.tableHeight = window.innerHeight - $(".table").offset().top - 70;
            }
          };
        }
      },
    },
    mounted() {
      // 获取页面表格高度
      this.getTableHeight();
      // 获取列表
      this.getList();
    }
  }
</script>

<style scoped>
  @import "../../assets/css/detaileds.css";/* 列表样式 */
</style>





// WEBPACK FOOTER //
// src/components/Menu/administratorsManagement.vue